import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-plan-cuentas',
  templateUrl: './modal-plan-cuentas.component.html',
  styleUrls: ['./modal-plan-cuentas.component.scss'],
})
export class ModalPlanCuentasComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
